import { socials } from "../../data/socials";

export default function Socials() {
  return (
    <>
      {socials.map((elm, i) => (
  <a
    key={i}
    href={elm.href}
    className="group rtl:ml-4 rtl:mr-0"
    aria-label={`Follow iForge on ${elm.icon}`}
  >
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon={elm.icon}
      className={`h-5 w-5 ${
        elm.icon === "youtube" ? "fill-[#FF6600]" : "fill-[#FF6600]"
      } group-hover:fill-[#020102] dark:group-hover:fill-white`}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={elm.icon === "youtube" ? "0 0 24 24" : "0 0 512 512"}
    >
      <path d={elm.svgPath}></path>
    </svg>
  </a>
))}

    </>
  );
}
